import { render, staticRenderFns } from "./TodayAnnouncements.vue?vue&type=template&id=e3c3bd5e&"
import script from "./TodayAnnouncements.vue?vue&type=script&lang=js&"
export * from "./TodayAnnouncements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports